import { API } from "."
import { makeParams } from "@/utils/helper"
import {
  CreateNotificationReadHistoryParams,
  CreateNotificationReadHistoryResponse,
  ReadLatestNotificationResponse,
  ReadNoticeListParams,
  ReadNotificationsResponse,
  ReadUnreadNoticeCountResponse,
} from "@/types/notice"

/* 호출 시 interceptor 에서 /teams/{idfTeam} 붙음 */

/* 공지 목록 조회 */
export async function readNotifications(params: ReadNoticeListParams) {
  return await API.get<ReadNotificationsResponse>("/notices", { params })
}

/* 공지 조회 이력 생성 */
// NOTE admin 권한이 있는 계정으로 공지를 읽을 경우 읽음 처리를 하지 않게 되어있음.
export async function CreateNotificationReadHistory(params: CreateNotificationReadHistoryParams) {
  const { idfNotice, isTeam } = params

  return await API.post<CreateNotificationReadHistoryResponse>(
    `/notices/${idfNotice}/read-history?isTeam=${isTeam}`,
  )
}

/* 최근 공지 조회 */
export async function readLatestNotification(language: string) {
  const params = makeParams({ language })

  return await API.get<ReadLatestNotificationResponse>("/notices/latest", { params })
}

/* 미열람 공지 개수 조회 */
export async function readUnreadNotificationCount() {
  return await API.get<ReadUnreadNoticeCountResponse>("/notices/unread-count")
}
